export default "__VITE_ASSET__aqa9uB4A__"